/**
 *  Login page — AJAX flow with plain JS validation (không dùng FormValidation
 *  để tránh crash undefined.length / null.classList trên server).
 */

"use strict";

const loginForm = document.querySelector("#formAuthentication");

function loginSetAlert(type, message) {
    const el = document.getElementById("loginAlert");
    if (!el) return;
    el.className = "alert mb-3 alert-" + type;
    el.textContent = message;
}

function loginClearAlert() {
    const el = document.getElementById("loginAlert");
    if (!el) return;
    el.className = "alert d-none mb-3";
    el.textContent = "";
}

function loginSetLoading(isLoading) {
    const btn = document.getElementById("loginSubmit");
    if (!btn) return;
    const spinner = btn.querySelector(".spinner-border");
    btn.disabled = isLoading;
    if (spinner) spinner.classList.toggle("d-none", !isLoading);
}

function loginShowFieldError(input, message) {
    if (!input) return;
    input.classList.add("is-invalid");
    let feedback = input.parentElement.querySelector(".invalid-feedback");
    if (input.parentElement.classList.contains("input-group")) {
        feedback = input.parentElement.parentElement.querySelector(":scope > .invalid-feedback");
    }
    if (!feedback) {
        feedback = document.createElement("span");
        feedback.className = "invalid-feedback d-block";
        const target = input.parentElement.classList.contains("input-group")
            ? input.parentElement
            : input;
        target.insertAdjacentElement("afterend", feedback);
    }
    feedback.innerHTML = "<strong>" + message + "</strong>";
    feedback.classList.add("d-block");
}

function loginClearFieldError(input) {
    if (!input) return;
    input.classList.remove("is-invalid");
    const wrapper = input.closest(".mb-3") || input.parentElement;
    const feedback = wrapper && wrapper.querySelector(".invalid-feedback");
    if (feedback) {
        feedback.classList.remove("d-block");
        feedback.innerHTML = "";
    }
}

function loginValidate(form, msgs) {
    let valid = true;
    const email = form.querySelector('[name="email"]');
    const password = form.querySelector('[name="password"]');

    loginClearFieldError(email);
    loginClearFieldError(password);

    if (email) {
        const v = email.value.trim();
        if (!v) {
            loginShowFieldError(email, msgs.emptyEmail);
            valid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
            loginShowFieldError(email, msgs.invalidEmail);
            valid = false;
        }
    }

    if (password && !password.value) {
        loginShowFieldError(password, msgs.emptyPassword);
        valid = false;
    }

    return valid;
}

function loginApplyServerErrors(errors) {
    Object.keys(errors).forEach(function (field) {
        const input = loginForm.querySelector('[name="' + field + '"]');
        if (!input) return;
        const msg = Array.isArray(errors[field]) ? errors[field][0] : errors[field];
        loginShowFieldError(input, msg);
    });
}

document.addEventListener("DOMContentLoaded", function () {
    if (!loginForm) return;

    const msgs = {
        emptyEmail: loginForm.dataset.msgEmptyEmail || "Please enter your email",
        invalidEmail: loginForm.dataset.msgInvalidEmail || "Please enter a valid email address",
        emptyPassword: loginForm.dataset.msgEmptyPassword || "Please enter your password",
    };

    loginForm.addEventListener("input", function (e) {
        if (e.target && e.target.classList.contains("is-invalid")) {
            loginClearFieldError(e.target);
        }
        const al = document.getElementById("loginAlert");
        if (al && !al.classList.contains("alert-success") && !al.classList.contains("d-none")) {
            loginClearAlert();
        }
    });

    loginForm.addEventListener("submit", async function (e) {
        e.preventDefault();
        if (!loginValidate(loginForm, msgs)) return;

        loginClearAlert();
        loginSetLoading(true);

        const csrfMeta = document.querySelector('meta[name="csrf-token"]');
        const csrfInput = loginForm.querySelector('input[name="_token"]');
        const csrfToken = (csrfMeta && csrfMeta.getAttribute("content")) || (csrfInput && csrfInput.value) || "";

        try {
            const response = await fetch(loginForm.action, {
                method: "POST",
                body: new FormData(loginForm),
                credentials: "same-origin",
                headers: {
                    "Accept": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-CSRF-TOKEN": csrfToken,
                },
            });

            let data = {};
            try { data = await response.json(); } catch (_) {}

            if (response.ok && data.success) {
                loginSetAlert("success", data.message || "Login successful");
                setTimeout(function () {
                    window.location.href = data.redirect || "/";
                }, 500);
                return;
            }

            if (response.status === 422 && data.errors) {
                // Field-level errors → chỉ hiện inline dưới input, KHÔNG show alert (tránh duplicate)
                loginApplyServerErrors(data.errors);
            } else if (response.status === 419) {
                loginSetAlert("danger", loginForm.dataset.msgSessionExpired || "Please reload the page and try again.");
            } else if (response.status === 429) {
                loginSetAlert("danger", (data && data.message) || "Too many attempts. Please wait a moment.");
            } else {
                loginSetAlert("danger", (data && data.message) || "Login failed. Please check your credentials.");
            }
        } catch (err) {
            loginSetAlert("danger", "Network error. Please try again.");
        } finally {
            loginSetLoading(false);
        }
    });
});
